module.exports = __webpack_public_path__ + "static/media/YB5M06_2.7627bb77.jpg";